import type { NavItem } from '../models/LayoutTypes';
import NavList from '../controls/NavList';

const NavPanel: React.FC<
  {title: string, items: NavItem[], compact?: boolean}
  > = ({ title, items, compact = false }) => {
    return (
      <div className="card p-2">
        <div className="mb-3 text-sm font-semibold uppercase tracking-wide text-slate-500">
          {title}
        </div>
        <NavList items={items} isCompact={compact} />
      </div>
    );
  };
export default NavPanel;
